import React from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';
import Content from '../Content';
import Field from '../Field';
import PathView from '../PathView';

const SettingsForm = ({
  loading,
  isSubmitting,
  handleSubmit,
  setFieldTouched,
  setFieldValue,
  values,
  errors,
  touched
}) => {
  const handleChange = (e, { name, value }) => setFieldValue(name, value);
  const handleBlur = name => setFieldTouched(name, true);
  return (
    <Content loading={loading || isSubmitting}>
      <PathView paths={[{ name: 'Settings' }]} />
      <Segment>
        <Form onSubmit={handleSubmit}>
          <Form.Group widths="equal">
            <Field error={errors.name} touched={touched.name}>
              <Form.Input
                label="Name *"
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Field>
            <Field error={errors.surname} touched={touched.surname}>
              <Form.Input
                label="Surname *"
                name="surname"
                value={values.surname}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Field>
            <Field error={errors.phoneNumber} touched={touched.phoneNumber}>
              <Form.Input
                label="Phone *"
                name="phoneNumber"
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Field
              error={errors.currentPassword}
              touched={touched.currentPassword}
            >
              <Form.Input
                label="Password *"
                type="password"
                name="currentPassword"
                value={values.currentPassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Field>
            <Field error={errors.password} touched={touched.password}>
              <Form.Input
                label="New Password"
                type="password"
                name="password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Field>
            <Field
              error={errors.passwordConfirmation}
              touched={touched.passwordConfirmation}
            >
              <Form.Input
                label="Confirm New Password"
                type="password"
                name="passwordConfirmation"
                value={values.passwordConfirmation}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Field>
          </Form.Group>
          <Button type="submit" primary>
            Save
          </Button>
        </Form>
      </Segment>
    </Content>
  );
};

export default SettingsForm;



// WEBPACK FOOTER //
// ./src/component/Settings/Form.js